module.exports = __webpack_public_path__ + "static/ping_lost.531312e8.jpg";